import { render, staticRenderFns } from "./statementConfirm.vue?vue&type=template&id=e281179e&scoped=true&"
import script from "./statementConfirm.vue?vue&type=script&lang=ts&"
export * from "./statementConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./statementConfirm.vue?vue&type=style&index=0&id=e281179e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e281179e",
  null
  
)

export default component.exports